import { gql } from '@apollo/client';

export const pageAssetsView = gql`
  query ($amount: Int!, $field: String!, $page: Int!, $filters: [FilterInput!], $csv: Boolean) {
    pageAssetsView(grid: { amount: $amount, field: $field, page: $page, filters: $filters, csv: $csv }) {
      count
      data {
        Status
        BarCode
        Description
        Description2
        Description3
        SerialNumber
        AssetNumber
        Owner
        OriginalPurchaser
        poNumber
        Location
        Acquired
        EquipmentClass
        AllComments
        VerifyDate
        UserId
        VerifyType
        Year
        Department
        CapitalSubDeptFund
        source
        needScan
        AssetID
        VerifyId
        DepartmentID
      }
    }
  }
`;

export const pageAssetsHistoryView = gql`
  query ($amount: Int!, $field: String!, $page: Int!, $filters: [FilterInput!], $csv: Boolean) {
    pageAssetsHistoryView(grid: { amount: $amount, field: $field, page: $page, filters: $filters, csv: $csv }) {
      count
      data {
        Status
        BarCode
        Description
        Description2
        Description3
        SerialNumber
        AssetNumber
        Owner
        OriginalPurchaser
        poNumber
        Location
        Acquired
        EquipmentClass
        AllComments
        VerifyDate
        UserId
        VerifyType
        Year
        Department
        CapitalSubDeptFund
        source
        needScan
        AssetID
        VerifyId
        DepartmentID
      }
    }
  }
`;

export const getAssetsByDept = (departmentId: any, filterField: any) => {
  return gql`
  query assetsByDepartment(
      $filterBuilderArray: [FilterBuilderInput!]
      $pageNumber: Int!
      $searchField: String
      $searchValue: String
      $sortField: String!
      $amount: Int!
      $sortOrder: String!
    ) 
  {
    assetsByDepartment(
    departmentId: ${departmentId} 
    filter: {
          amount: $amount
          page: $pageNumber
          field: $sortField
          sort: $sortOrder
          searchFilter: { searchValue: $searchValue, searchField: $searchField }
        }
    filterField: "${filterField}"
    filterBuilderArray: $filterBuilderArray
    )
      {
        BarCode
        Status
        Department
        Owner
        Location
        Description
        Description2
        Description3
        AssetNumber
        SerialNumber
        Acquired
        Year
        needScan
      }
    }
    `;
};

export const getVerificationById = gql`
  query verificationById($verifyId: Float!) {
    verificationById(id: $verifyId) {
      VerifyId
      Status
      AssetNumber
      BarCodeNumber
      VerifyDate
      UserId
      userDepartment {
        id
        Name
        Abbreviation
      }
      Type
      itemDepartment {
        id
        Name
        Abbreviation
      }
      latitude
      longitude
      transferTo
      PhysicalOwner
    }
  }
`;

export const getAssetByBarcode = gql`
  query assetsViewByBarcode($barcode: String!) {
    assetsViewByBarcode(barcode: $barcode) {
      BarCode
      AssetNumber
      VerifyId
      Year
      AssetID
      SerialNumber
    }
  }
`;

export const getAssetByAssetNumber = gql`
  query assetsViewByAssetNumber($assetNumber: String!) {
    assetsViewByAssetNumber(assetNumber: $assetNumber) {
      BarCode
      AssetNumber
      VerifyId
      Year
      AssetID
      SerialNumber
    }
  }
`;
